import { render, staticRenderFns } from "./TelaDeManutencaoDeProdutosDePara.vue?vue&type=template&id=11c15e8b&scoped=true&"
import script from "./TelaDeManutencaoDeProdutosDePara.vue?vue&type=script&lang=ts&"
export * from "./TelaDeManutencaoDeProdutosDePara.vue?vue&type=script&lang=ts&"
import style0 from "./TelaDeManutencaoDeProdutosDePara.vue?vue&type=style&index=0&id=11c15e8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c15e8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
